/**
 * Wrap a dynamic `import()` so a transient network blip retries with a short
 * backoff before giving up. Pairs with `RouteError` (which handles the
 * stale-deploy chunk-miss case with a one-time reload) — this covers the
 * flaky-connection case where the chunk still exists but the first fetch
 * failed.
 *
 * Usage: `lazy(() => retryImport(() => import('./heavy')))`
 */
export function retryImport<T>(factory: () => Promise<T>, retries = 2, delayMs = 400): Promise<T> {
  return factory().catch((err: unknown) => {
    if (retries <= 0) throw err;
    return new Promise<void>((r) => setTimeout(r, delayMs)).then(() =>
      retryImport(factory, retries - 1, delayMs),
    );
  });
}
